// Module
var code = "<div class=\"sessions\" ng-class=\"urlPrefix\"><sessions-navigation url-prefix=\"urlPrefix\"></sessions-navigation><forgot-password-form></forgot-password-form><footer class=\"login-register-footer\"><p class=\"sign-in-link\" translate-compile translate-once=\"authentication.forgot_password.return_to_login\"></p></footer></div>";
// Exports
export default code;